import React, { useEffect, useState } from "react";
import { Button, Space, Table, Tag, Modal, Tooltip, Switch, message } from "antd";
import ConfirmationModal from "../../Pages/SuperAdmin/Team/ConfirmationModal";
import {
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlineArrowUp,
} from "react-icons/ai";
import { getAllFunctionDefinitions, deleteFunctionDefinition, getSingleFunctionDefinitions} from "../../Pages/SuperAdmin/api/functionDefinition";
import { getUser } from "../../api/user";
import { getUserID, getUserRole } from "../../Utility/service";
import {
  handleValidateFunction,
  renderParameterInputs,
  handleSaveFunctionToDB,
} from "../../Pages/SuperAdmin/api/functionDefinition";
import FunctionDefinitionModel from "../../Pages/SuperAdmin/Modals/FunctionDefinitionModal";
import ValidationModel from "../../Pages/SuperAdmin/Modals/ValidationModel";
//-----Helper----------//
import { redirectToAssistant } from "../../Utility/assistant-helper"
import { get } from "react-scroll/modules/mixins/scroller";
import ProfileHeader from "../Proflie/ProfileHeader";
import { LucideSquareFunction } from "lucide-react";

const { confirm } = Modal;
// const userId = getUserID();
// const userRole = getUserRole();
const FunctionCallingAssistantTable = ({ data }) => {
  const {
    functionCallingAssistants,
    setFunctionCallingAssistants,
    loader,
    handleDeleteAssistant,
    handleUpdateAssistant,
    // showEditModalHandler,
    handleFetchFunctionCallingAssistants,
    updateLoader,
    setActiveKey,
    toggleDefineFunctionsModal,
    userId,
    userRole,
    refreshTrigger,
    setRefreshTrigger
  } = data;
  const [functionIdToDelete, setFunctionIdToDelete] = useState(null);
  const [functionDefinitions, setFunctionDefinitions] = useState([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [editFunctionModalOpen, setEditFunctionModalOpen] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validateConsole, setValidateConsole] = useState("");
  const [parameterValues, setParameterValues] = useState({});
  const [userMap, setUserMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [functionToEdit, setFunctionToEdit] = useState(null);
  const [definitionToValidate, setDefinitionToValidate] = useState("");
  const [functionName, setFunctionName] = useState("");
  const [functionsParameterNames, setFunctionsParameterNames] = useState([]);
  const [functionDefinition, setFunctionDefinition] = useState("");
  const [functionBody, setFunctionBody] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const handleParameterChange = (event) => {
    const { name, value } = event.target;
    setParameterValues({
      ...parameterValues,
      [name]: value,
    });
  };

  const validateFunctionDefinition = async (definition) => {
    setDefinitionToValidate(definition);
  }
  

  const getAllfunctions = async () => {
    try {
      setLoading(true);
      const functions = await getAllFunctionDefinitions();
      setFunctionDefinitions(functions);
      const userIds = [
        ...new Set(functions.map((item) => item.userId).filter(Boolean)),
      ];
      if (userIds.length === 0) {
        setUserMap({});
        return;
      }
      const userPromises = userIds.map((id) => getUser(id));
      const users = await Promise.all(userPromises);
      const userInfoMap = {};
      users.forEach((userInfo) => {
        if (userInfo && userInfo.data && userInfo.data.user) {
          userInfoMap[userInfo.data.user._id] = userInfo.data.user; // Map to user object
        }
      });
      setUserMap(userInfoMap);
    } catch (error) {
      console.error("Error fetching functions or users:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteFunction = async (id) => {
    try {
      setLoading(true);
      const { success, message: responseMessage } = await deleteFunctionDefinition(id);
      if (success) {
        message.success(responseMessage);
        getAllfunctions();
        setConfirmationModalOpen(false);
      } else {
        message.error(responseMessage);
      }
    } catch (error) {
      console.error("Error deleting function:", error);
      message.error("Failed to delete function.");
    } finally {
      setLoading(false);
      setConfirmationModalOpen(false);
    }
  };

  const handleFunctionNameChange = (value) => {
    setFunctionName(value);
    updateFunctionDefinition(value);
  };

  const showEditModalHandler = (record) => {
    setFunctionToEdit(record);
    const functionBody = record.definition.match(/\{([\s\S]*)\}/)?.[1]?.trim();
    setFunctionName(record.name);
    setFunctionsParameterNames(record.parameters.properties);
    setFunctionBody(functionBody);
    setFunctionDefinition(
      `function ${record.name}(${Object.keys(record.parameters.properties).join(', ')}) {\n${functionBody}\n}`
    );
    setEditFunctionModalOpen(true);
  };

  const showDeleteConfirm = (id) => {
    setFunctionIdToDelete(id);
    setConfirmationModalOpen(true);
  };

  const toggleValidationModal = () => {
    setShowValidationModal(!showValidationModal);
  };

  const refreshTable = () => {
    setLoading(true);
    getAllfunctions().finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    
    getAllfunctions(); // Fetch data on initial render
  }, []);

  const updateFunctionDefinition = (newName) => {
    if (functionToEdit && functionToEdit.parameters && functionToEdit.parameters.properties) {
      const parameters = Object.keys(functionToEdit.parameters.properties).join(', ');
      setFunctionDefinition(
        `function ${newName}(${parameters}) {\n${functionBody}\n}`
      );
    }
  };

  useEffect(() => {
    if (editFunctionModalOpen && functionToEdit) {
      updateFunctionDefinition(functionName);
    }
    if (!editFunctionModalOpen) {
      setFunctionToEdit(null);
    }
  }, [editFunctionModalOpen, functionToEdit]);


  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      align: "left",
      render: (text) => <span className="text-left">{text}</span>,
    },
    {
      title: "Description",
      key: "description",
      align: "left",
      dataIndex: "description",
      render: (text) => <span className="text-left">{text}</span>,
    },
    {
      title: "Parameters",
      key: "parameters",
      align: "left",
      dataIndex: "parameters",
      render: (text) => <span className="text-left">{text?.properties ? Object.keys(text.properties).join(', ') : ""}</span>,
    },
    {
      title: "Created By",
      align: "center",
      dataIndex: "userId",
      key: "userId",
      render: (userId) => {
        if (!userId) {
          return <span className="text-left">N/A</span>;
        }
        const user = userMap[userId];
        const fname = user ? user.fname : "Unknown";
        return <span className="text-left">{fname}</span>;
      },
    },
    ...(userRole === 'superadmin' ? [{
      title: "Actions",
      key: "actions",
      align: "center",
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title="Edit">
            <Button
              type="primary"
              icon={<AiOutlineEdit />}
              onClick={() => showEditModalHandler(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="danger"
              icon={<AiOutlineDelete />}
              onClick={() => showDeleteConfirm(record._id)}
            />
          </Tooltip>
        </Space>
      ),
    }] : []),
  ];

  useEffect(() => {
    refreshTable();
  },[refreshTrigger]);

  return (
    <div>
      <ProfileHeader title="All Functions" subHeading=" View and manage all custom AI functions." />
      <div className="agent-page-section-wrapper">
        <div className={`${functionDefinitions?.length === 0 ? 'create-function-button-loading' : 'create-function-button'}`}>
          <Button
            onClick={() => {
              // Reset any edit-specific states if necessary
              setFunctionToEdit(null);
              toggleDefineFunctionsModal();
              
            }}
          >
           <LucideSquareFunction/> Create Functions
          </Button>
        </div>
        <Table
          columns={columns}
          dataSource={functionDefinitions}
          rowKey="id"
          className={`${functionDefinitions?.length === 0 ? 'mt-5' : 'mt-0'}`}
          loading={loading}
          scroll={{ y: "50vh" }}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            showSizeChanger: true,
            position: ["topRight"],
            onShowSizeChange: (current, size) => {
              setPageSize(size);
              setCurrentPage(1);
            },
            onChange: (page) => setCurrentPage(page),
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
          }}
        />
      </div>
      

      {/* Edit Function Modal */}
      {functionToEdit && (
        <FunctionDefinitionModel
          refresh={refreshTable}
          data={{
            editMode: true,
            showDefineFunctionsModal: editFunctionModalOpen,
            toggleDefineFunctionsModal: () => setEditFunctionModalOpen(false),
            functionTitle: functionToEdit.title,
            // functionName: functionToEdit.name,
            functionName: functionName,
            // handleFunctionNameChange: (value) => setFunctionToEdit({ ...functionToEdit, name: value }),
            handleFunctionNameChange: handleFunctionNameChange,
            functionsParameterNames: functionToEdit.parameters && functionToEdit.parameters.properties
              ? Object.keys(functionToEdit.parameters.properties).map(key => ({
                name: key,
                type: functionToEdit.parameters.properties[key].type,
                description: functionToEdit.parameters.properties[key].description,
              }))
              : [],
            demoFunctionDefinition: functionToEdit.definition,
            functionDescription: functionToEdit.description,
            setFunctionsParameterNames: (params) =>
              setFunctionToEdit({
                ...functionToEdit,
                parameters: {
                  ...functionToEdit.parameters,
                  properties: params.reduce((acc, param) => {
                    acc[param.name] = { type: param.type, description: param.description };
                    return acc;
                  }, {}),
                },
              }),
            // functionDefinition: functionToEdit.definition,
            functionDefinition: functionDefinition,
            functionInstruction: functionToEdit.instruction,
            functionId: functionToEdit._id,
            toggleValidationModal: toggleValidationModal,
            setFunctionName: (name) =>
              setFunctionToEdit({ ...functionToEdit, name }),
            setFunctionDefinition: (def) =>
              setFunctionToEdit({ ...functionToEdit, functionDefinition: def }),
            setShowDefineFunctionsModal: () =>
              setEditFunctionModalOpen(false),
            validateFunctionDefinition,
          }}
        />
      )}

      {
        showValidationModal && (
          <ValidationModel
        data={{
          showValidationModal,
          toggleValidationModal,
          renderParameterInputs,
          functionsParameterNames: functionToEdit.parameters && functionToEdit.parameters.properties
              ? Object.keys(functionToEdit.parameters.properties).map(key => ({
                name: key,
                type: functionToEdit.parameters.properties[key].type,
                description: functionToEdit.parameters.properties[key].description,
              }))
              : [],
          parameterValues,
          setParameterValues,
          handleParameterChange,
          validateConsole,
          handleValidateFunction,
          setValidateConsole,
          functionDefinition: definitionToValidate,
          functionName: functionToEdit.name,
        }}
      />
        )
      }

      {/* Confirmation Modal */}
      <ConfirmationModal
        open={confirmationModalOpen}
        onConfirm={() => handleDeleteFunction(functionIdToDelete)}
        onCancel={() => setConfirmationModalOpen(false)}
        content="Are you sure you want to delete this function?"
      />
    </div>
  );

};

export default FunctionCallingAssistantTable;
